// extracted by mini-css-extract-plugin
export default {"breakdown-content":"components-parity-charts-chart-issue-type-module__breakdown-content"};